import React from 'react';
import TableColumnTitle from '../../../../../components/_table/TableColumnTitle';
import TableColumnImg from '../../../../../components/table/TableColumnImg';
import { EVENT_STATUS_TEXT } from '../../../../../constants/service/app/eventConstants';

/**
 *  추천 기획전에 연결된 기획전 아이템 리스트 컬럼
 */
export const columns = () => {
  return [
    {
      title: <TableColumnTitle title={'이미지'} />,
      dataIndex: 'url',
      render: (value) => <TableColumnImg url={value} width={'60px'} height={'60px'} />,
    },
    {
      title: <TableColumnTitle title={'기획전 번호'} />,
      dataIndex: 'id',
    },
    {
      title: <TableColumnTitle title={'상태'} />,
      dataIndex: 'status',
      render: (value) => EVENT_STATUS_TEXT[value],
    },
    {
      title: <TableColumnTitle title={'제목'} />,
      dataIndex: 'mainTitle',
    },
    {
      title: <TableColumnTitle title={'기간'} />,
      dataIndex: 'eventPeriod',
    },
  ];
};
